<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										Single Chart of Account
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 ms-5 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :form="form" @filterAction="filterAction" :filter="filter"
										:is_single_coa="true"></report-filter>
									<b-button @click="printPDF" class="btn-sm me-2 akkurate-green-btn akkurate-small"
										title="Print">
										<font-awesome-icon :icon="['fas', 'print']" />
									</b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small"
										title="Download">
										<font-awesome-icon :icon="['fas', 'download']" />
									</b-button>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div ref="pdfContent">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution"
										:title="'Chart of Account Transactions'">
									</statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list }}
									</div>
									<div class="col-12 small">
										Chart of account : {{ coa_list }}
									</div>
								</div>

								<div class="row">
									<div class="col-md-6 col-6 text-center bd-highlight d-flex mt-auto"
										style="flex-direction: column">
										<span class="mt-1" style="text-align: left">Opening Bal.:
											<strong>{{ institution?.currency_code }} {{ displayNumber(getOpeningBal())
												}}</strong>
										</span>
										<span class="mt-1" style="text-align: left">Closing Bal.:
											<strong>{{ institution?.currency_code }} {{ displayNumber(total_balance)
												}}</strong>
										</span>
									</div>
									<div class="col-md-6 col-6 text-end bd-highlight mt-auto">
										<div>
											Terms: <span class="fw-bold">{{ form.terms }}</span>
										</div>
										<span class="me-4">Difference : <span class="fw-bold">{{ displayNumber(total_balance)}}</span></span>
										<span class="mt-2"> From:
											<strong>{{ form.start_date }}</strong>
											To:
											<strong>{{ form.end_date }}</strong>
										</span>
										
									</div>
								</div>
								<div class="row">
									<div class="col-12 col-md-12 trans_details">
										<b-table id="chart-of-account" striped bordered responsive :busy.sync="isBusy"
											:items="items.map((item) => {
												return {
													...item,
													dr_amount_display:
														this.displayNumber(
															item.dr_amount
														),
													cr_amount_display:
														this.displayNumber(
															item.cr_amount
														),
													current_amount_display:
														this.displayNumber(
															item.current_amount
														),
												};
											})
												" :fields="fields" :tbody-tr-class="rowClass" show-empty>
											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #custom-foot>
												<b-tr>
													<b-th colspan="3"></b-th>
													<b-th>TOTAL</b-th>
													<b-th>{{
														displayNumber(
															total_debit
														)
													}}</b-th>
													<b-th>{{
														displayNumber(
															total_credit
														)
													}}</b-th>
													<b-th>{{
														displayNumber(total_balance)
													}}</b-th>
												</b-tr>
											</template>
										</b-table>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 trans_details">
									<div class="d-flex justify-content-between">
										<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
											:total-rows="totalRecords" :per-page="perPage"
											aria-controls="member-table"></b-pagination>
										<div class="col text-end mt-1 akkurate-dark">
											<div>
												{{ currentPage }} -
												{{ perPage }} of
												{{ totalRecords }}
											</div>
											<b-form-group label="Per Page" label-size="sm" class="mb-0">
												<b-form-select @change="selectPerPage" id="per-page-select"
													v-model="perPage" :options="per_page_options"
													size="sm"></b-form-select>
											</b-form-group>
										</div>
									</div>
									<!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top">
			<i class="fas fa-angle-up"></i>
		</a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ApiService from "@/core/services/api.service";
import html2pdf from "html2pdf.js";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import Multiselect from "vue-multiselect";
import ReportFilter from "../form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	props: ["id"],
	mounted() {
		// this.getCustomerProduct();
		this.getInstitution();
		this.getProductDropdown();
	},
	computed: {
		rows() {
			return this.items.length;
		},
	},

	data() {
		return {
			form: {
				start_date: this.getOneMonthEailer(),
				end_date: new Date().toISOString().split("T")[0],
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "YTD",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			filter: {
				branches: false,
				products: false,
				users: false,
				status: false,
				condition: false,
				coa: true,
				terms: true,
				start_date: true,
				end_date: true,
				loan_status:false,
			},
			total_balance:"",
			branch_list: "",
			coa_list: "",
			search: "Search",
			isBusy: false,
			isSearching: false,
			gender: "",
			gender_options: ["Male", "Female"],
			isLoadingInstitution: false,
			institution: "",
			categories_options: ["STANDARD", "PRODUCT", "USER"],
			per_page_options: ["10", "20", "50", "100","500"],
			currentPage: 1,
			perPage: 10,
			totalRecords: 0,
			fields: [
				{
					key: "transaction_date",
					label: "Transaction Date",
				},
				{
					key: "transaction_description",
					label: "Description",
				},
				{
					key: "teller",
					label: "Teller",
				},
				{
					key: "branch_name",
					label: "Branch",
				},

				{
					key: "dr_amount_display",
					label: "DR",
				},
				{
					key: "cr_amount_display",
					label: "CR",
				},
				{
					key: "current_amount_display",
					label: "Balance (GHS)",
				},
			],
			perPage: 20,
			currentPage: 1,
			items: [],
			total_debit: "",
			total_credit: "",
		};
	},
	methods: {
		rowClass() {
			return "custom-row-height";
		},
		navigatePage(index) {
			this.isLoading = true;
			this.currentPage = index;
			this.getCustomerProduct();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.getCustomerProduct();
		},
		getOpeningBal() {
			let opening_bal = 0;
			if (this.items.length > 0) {
				opening_bal = this.items[0].current_amount;
			}

			return opening_bal;
		},
		async getProductDropdown() {
			this.isBusy = true;
			this.search = "Processing...";
			await ApiService.query("/reports/controls/products/dropdown")
				.then((response) => {
					// console.log(response.data);
					this.isBusy = false;
					this.search = "Search";
					this.form.branch_options = response.data.branches;
					this.form.product_options = response.data.products;
					this.form.coa_options = response.data.coa_subheads;
				})
				.catch((error) => {
					// console.log(error);
					this.isBusy = false;
					this.search = "Search";
				});
		},
		async getCustomerProduct() {
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			// let coa_subhead = this.form.coa.map((index) => {
			//   return index.id;
			// });

			let coa_subhead = [];
			if (this.form.coa) {
				coa_subhead[0] = this.form.coa.id;
			}
			const branches = this.form.branches.map((index) => {
				return index.id;
			});
			const categories = this.form.categories.map((value) => {
				return value;
			});
			// console.log(this.form.terms);
			await ApiService.query("/reports/financials/coa/single", {
				params: {
					page: this.currentPage,
					per_page: this.perPage,
					startDate: this.form.start_date,
					endDate: this.form.end_date,
					coa: coa_subhead,
					branches: branches,
					categories: categories,
					terms: this.form.terms, //["YTD","Periodic"]
				},
			})
				.then((response) => {
					this.items = [];
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					this.$Progress.start();
					this.branch_list = this.form.coa?.coabranch?.name;
					this.coa_list = this.form.coa.code + " - " + this.form.coa.name;
					this.total_debit = response.data.date_range?.range_dr_total;
					this.total_credit = response.data.date_range?.range_cr_total;
					// this.balance = response.data.page_summary?.page_balance;
					this.total_balance = response.data.date_range?.range_balance;
					this.totalRecords = response.data.pagination.total;
					// this.items = response.data.map((index) => {
					//   return {
					//     trans_date: index.trans_date,
					//     description: index.description,
					//     coa_subheads: index.coa_subheads,
					//     cr_amount: index.cr_amount,
					//     dr_amount: index.dr_amount,
					//     balance: index.balance,
					//     previous_amount: index.previous_amount,
					//   };
					// });
					let coa_trans = response.data.data?.map((index) => {
						const first_name =
							index.created_user?.first_name ?? "";
						const surname = index.created_user?.surname ?? "";
						return {
							transaction_date: index.transaction_date,
							transaction_description:
								index.transaction_description,
							branch_name: index.branch?.name,
							dr_amount: index.dr_amount,
							cr_amount: index.cr_amount,
							previous_amount: index.previous_amount,
							current_amount: index.current_amount,
							//Display Amount
							dr_amount_display: this.displayNumber(
								index.dr_amount
							),
							cr_amount_display: this.displayNumber(
								index.cr_amount
							),
							previous_amount_display: this.displayNumber(
								index.previous_amount
							),
							current_amount_display: this.displayNumber(
								index.current_amount
							),
							teller: first_name + " " + surname,
						};
					});
					// this.items = response.data.data;
					let balance_bf = 0;

					if (
						coa_trans &&
						coa_trans.length &&
						coa_trans.length > 0
					) {
						balance_bf = coa_trans[0].previous_amount ?? 0;
						let increase_by =
							coa_trans.coasubhead?.coahead?.headtype
								?.increase_by;
						let bf_cr_amount = "";
						let bf_dr_amount = "";

						if (increase_by == "Credit") {
							let amt = balance_bf;
							//if amount is positive, it is a credit
							if (amt >= 0) {
								bf_cr_amount = balance_bf;
							} else {
								// convert to positive number

								bf_dr_amount = balance_bf * -1;
							}
						} else {
							let amt = balance_bf;
							//if amount is positive, it is a debit
							if (amt >= 0) {
								bf_dr_amount = balance_bf;
							} else {
								bf_cr_amount = balance_bf * -1;
							}
						}

						let newObj = {
							transaction_date: this.form.start_date,
							transaction_description: "BALANCE B/F",
							coa_subheads: "",
							cr_amount: bf_cr_amount,
							dr_amount: bf_dr_amount,
							current_amount: balance_bf,
							previous_amount: "",
							current_amount_display:
								this.displayNumber(balance_bf),
						};

						coa_trans.unshift(newObj);
					}
					this.items = coa_trans;
					// console.log(response);
				})
				.catch((error) => {
					this.isBusy = false;
					this.isSearching = false;
					this.search = "Search";
					console.log(error);
					this.$Progress.fail();
				})
				.finally(() => {
					this.$Progress.finish();
				});
		},
		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		getOneMonthEailer() {
			let currentDate = new Date();
			// Subtract one month
			currentDate.setMonth(currentDate.getMonth() - 1);
			// Convert the date to ISO string and extract only the date part
			let oneMonthEarlier = currentDate.toISOString().substr(0, 10);
			return oneMonthEarlier;
		},
		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		filterAction() {
			this.changePerPageNumber(this.perPage);
		},
		changePerPageNumber(data) {
			if (data == "All") {
				this.perPage = this.items.length;
				this.getCustomerProduct();
			} else {
				this.perPage = data;
				this.getCustomerProduct();
			}
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
		getOneMonthBeforeDate() {
			// Get today's date
			let currentDate = new Date();

			// Remove one month to the current date
			currentDate.setMonth(currentDate.getMonth() - 1);

			// Format the date as 'YYYY-MM-DD'
			return currentDate.toISOString().substr(0, 10);
		},
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const date =
				"FROM: " +
				this.form.start_date +
				" TO: " +
				this.form.end_date;
			const terms = "TERMS:  " + this.form.terms;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`L${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`L${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				}; // Bold and bigger font for name

				ws.getCell(`L${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`L${institutionDetailsRow + 1}`).font = {
					size: 12,
				}; // Regular font size for address

				ws.getCell(`L${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`L${institutionDetailsRow + 2}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`L${institutionDetailsRow + 3}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`L${institutionDetailsRow + 4}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 6}`).value = date;
				ws.getCell(`L${institutionDetailsRow + 6}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 7}`).value = terms;
				ws.getCell(`L${institutionDetailsRow + 7}`).font = {
					size: 12,
				}; // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn("K").width = 50; // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"Transaction Date",
					"Description",
					"Teller",
					"Branch",
					"DR",
					"CR",
					"Balance (GHC)",
				];

				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item

				this.items.forEach((item) => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.transaction_date,
						item.transaction_description, // Remove extra spaces
						item.previous_amount,
						item.branch?.name,
						item.dr_amount,
						item.cr_amount,
						item.current_amount_display,
					];
					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "Modified_REPORT_TEMPLATE.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
	},
};
</script>

<style scoped>
/* Customize the pagination page number color */
.pagination {
	--bs-pagination-active-bg: rgb(1, 134, 115) !important;
	--bs-pagination-active-border-color: rgb(1, 134, 115) !important;
	--bs-pagination-focus-box-shadow: none !important;
}

.page-link {
	color: rgb(1, 134, 115) !important;
}

.page-link:hover {
	color: rgb(1, 134, 115) !important;
}

.page-link.active,
.active>.page-link {
	color: #fff !important;
}
</style>
